/* eslint-disable import/no-internal-modules */
import React from 'react';
import styled from 'styled-components';
import { SettingType } from 'api/advanced-settings/settings-types';
import { ReactComponent as TwoFactorAuthIcon } from 'assets/svgs/two-factor-authentication.svg';
import { Switch } from 'components/atoms/switch/switch';
import { useTranslation } from 'hooks/use-translation';
import {
  useMutateAdvancedSettingsConfig,
  useQueryAdvancedSettingsConfig,
} from 'queries/advanced-settings/advanced-settings';
import { SettingsLabelWithoutMargin } from '../module-settings/styles';

const Container = styled.div`
  margin-top: var(--spacing-09);
`;

const StyledSettingsLabelWithoutMargin = styled(SettingsLabelWithoutMargin)`
  margin-left: var(--spacing-03);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  vertical-align: center;
  padding: var(--spacing-05);
  border-bottom: 1px solid var(--gray-20);
`;

const SectionContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-05);
`;

const SectionDescription = styled.p`
  width: 50%;
`;

export const TwoFactorAuthentication = () => {
  const { data: advancedSettingsConfig = [], status } =
    useQueryAdvancedSettingsConfig();
  const { mutate } = useMutateAdvancedSettingsConfig();
  const title = useTranslation(
    'settings.security.two.factor.authentication.title',
  );
  const description = useTranslation(
    'settings.security.two.factor.authentication.description',
  );

  const isOtpEnabled =
    advancedSettingsConfig.find(
      (event) => event.eventType === SettingType.OtpAuthentication,
    )?.eventValue ?? false;

  const toggle2faConfig = (checked: boolean) => {
    mutate({
      eventType: SettingType.OtpAuthentication,
      eventValue: checked,
    });
  };

  return (
    <Container>
      <SectionHeader>
        <TwoFactorAuthIcon />
        <StyledSettingsLabelWithoutMargin>
          {title}
        </StyledSettingsLabelWithoutMargin>
      </SectionHeader>
      <SectionContent>
        <SectionDescription>{description}</SectionDescription>
        <Switch
          loading={status === 'loading'}
          checked={isOtpEnabled}
          onChange={toggle2faConfig}
        />
      </SectionContent>
    </Container>
  );
};
